import { render, staticRenderFns } from "./face_detection12306.vue?vue&type=template&id=6d481bc6&"
import script from "./face_detection12306.vue?vue&type=script&lang=js&"
export * from "./face_detection12306.vue?vue&type=script&lang=js&"
import style0 from "./face_detection12306.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports